export { default as isPotentiallyLowEndDevice } from './isPotentiallyLowEndDevice'
